import {FilterKey, ValueFilter} from '../../../util/filterTypes';

export const getAliasFromFilterString = (
  filterString: string | undefined
): string => {
  if (!filterString) {
    return '';
  }
  let filterParsed: any;
  let alias = '';
  try {
    filterParsed = JSON.parse(filterString);
    // eslint-disable-next-line no-prototype-builtins
    if (filterParsed.hasOwnProperty('filter')) {
      filterParsed = JSON.parse(filterParsed.filter);
    }
  } catch (e) {
    // There isn't a better way to convert JSON string back to Filter
    console.warn(
      `error parsing trigger filter json.\nfilter: ${filterString}\nerror: ${e}`
    );
  }
  try {
    alias = filterParsed.$or[0].$and[0].alias.$regex;
  } catch (e) {
    console.warn(`error getting alias from filter: ${e}`);
  }
  return alias;
};

export const createAliasFilter = (alias: string): ValueFilter<FilterKey> => {
  return {
    key: {section: 'artifact', name: 'alias'},
    op: 'REGEX',
    value: alias,
  };
};
